<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  mounted() {
    const languageMappings = {
      zh: "zh-hk",
      cn: "zh-CN",
      en: "en",
      ja: "ja",
      ar: "ar",
      fr: "fr",
      de: "de",
      es: "es",
      it: "it",
      pt: "pt",
      id: "id",
      th: "th",
      tr: "tr",
      kr: "kr",
      vi: "vi",
      ru: "ru",
      pt: "pt",
    };
    if (!localStorage.getItem("lang")) {
      const la = navigator.language.toLowerCase();
      if (languageMappings[la]) {
        localStorage.setItem("lang", la);
      } else {
        localStorage.setItem("lang", "ko");
      }
    }
  },
};
</script>

<style>
#app {
  width: 100%;
  height: 100%;
  background: #fff;
}

::-webkit-scrollbar {
  display: none;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #b2ef4c;
}

.red {
  color: #f23c48;
}

.blue {
  color: #1fae87;
}
</style>
